import { formatDistanceToNowStrict, format } from "date-fns";

export function dateTime(value: string) {
  if (!value) {
    return "";
  }
  return format(new Date(value), "yyyy-MM-dd HH:mm");
}

export function ago(value: string) {
  if (!value) {
    return "";
  }
  return formatDistanceToNowStrict(new Date(value), { addSuffix: true });
}
